import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d786f232 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _288d110a = () => interopDefault(import('../../../pages/accessibility-statement.vue' /* webpackChunkName: "pages/accessibility-statement" */))
const _e8ad238a = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _45b2af8f = () => interopDefault(import('../../../pages/careers.vue' /* webpackChunkName: "pages/careers" */))
const _1a8a304e = () => interopDefault(import('../../../pages/CC33/index.vue' /* webpackChunkName: "pages/CC33/index" */))
const _78bdd2e2 = () => interopDefault(import('../../../pages/checker.vue' /* webpackChunkName: "pages/checker" */))
const _9ecd369a = () => interopDefault(import('../../../pages/checker2.vue' /* webpackChunkName: "pages/checker2" */))
const _119a8c69 = () => interopDefault(import('../../../pages/cookies.vue' /* webpackChunkName: "pages/cookies" */))
const _6df5d33c = () => interopDefault(import('../../../pages/elmo/index.vue' /* webpackChunkName: "pages/elmo/index" */))
const _2d5bd42a = () => interopDefault(import('../../../pages/emergency.vue' /* webpackChunkName: "pages/emergency" */))
const _57886ea6 = () => interopDefault(import('../../../pages/energy-source-vote.vue' /* webpackChunkName: "pages/energy-source-vote" */))
const _48a089ce = () => interopDefault(import('../../../pages/esb.vue' /* webpackChunkName: "pages/esb" */))
const _2958f31a = () => interopDefault(import('../../../pages/get-a-quote.vue' /* webpackChunkName: "pages/get-a-quote" */))
const _6e571e7f = () => interopDefault(import('../../../pages/heat-pump.vue' /* webpackChunkName: "pages/heat-pump" */))
const _6d9e8f90 = () => interopDefault(import('../../../pages/justmovein.vue' /* webpackChunkName: "pages/justmovein" */))
const _f791ac26 = () => interopDefault(import('../../../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _4732c4a8 = () => interopDefault(import('../../../pages/modern-slavery-statement.vue' /* webpackChunkName: "pages/modern-slavery-statement" */))
const _91068f50 = () => interopDefault(import('../../../pages/moving-home.vue' /* webpackChunkName: "pages/moving-home" */))
const _3236e1de = () => interopDefault(import('../../../pages/moving-in.vue' /* webpackChunkName: "pages/moving-in" */))
const _6fc4d03f = () => interopDefault(import('../../../pages/our-energy.vue' /* webpackChunkName: "pages/our-energy" */))
const _696953a8 = () => interopDefault(import('../../../pages/our-tariffs.vue' /* webpackChunkName: "pages/our-tariffs" */))
const _00a9d070 = () => interopDefault(import('../../../pages/policy.vue' /* webpackChunkName: "pages/policy" */))
const _42bdc519 = () => interopDefault(import('../../../pages/prepayment.vue' /* webpackChunkName: "pages/prepayment" */))
const _a44886c6 = () => interopDefault(import('../../../pages/press.vue' /* webpackChunkName: "pages/press" */))
const _5e416e3c = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _e89cdb54 = () => interopDefault(import('../../../pages/quote.vue' /* webpackChunkName: "pages/quote" */))
const _69e08059 = () => interopDefault(import('../../../pages/quote/index.vue' /* webpackChunkName: "pages/quote/index" */))
const _e987c47c = () => interopDefault(import('../../../pages/quote/payment-details.vue' /* webpackChunkName: "pages/quote/payment-details" */))
const _37c11b04 = () => interopDefault(import('../../../pages/quote/personal-details.vue' /* webpackChunkName: "pages/quote/personal-details" */))
const _677f0bc8 = () => interopDefault(import('../../../pages/quote/select-tariff.vue' /* webpackChunkName: "pages/quote/select-tariff" */))
const _6e74f7cf = () => interopDefault(import('../../../pages/r/index.vue' /* webpackChunkName: "pages/r/index" */))
const _20e35554 = () => interopDefault(import('../../../pages/refer-terms.vue' /* webpackChunkName: "pages/refer-terms" */))
const _4e3204fe = () => interopDefault(import('../../../pages/refund-policy.vue' /* webpackChunkName: "pages/refund-policy" */))
const _6d44d016 = () => interopDefault(import('../../../pages/reviews.vue' /* webpackChunkName: "pages/reviews" */))
const _85f8cb3a = () => interopDefault(import('../../../pages/so-flex-tariff-rates.vue' /* webpackChunkName: "pages/so-flex-tariff-rates" */))
const _67657e13 = () => interopDefault(import('../../../pages/so-out-of-contract-tariff.vue' /* webpackChunkName: "pages/so-out-of-contract-tariff" */))
const _4152dd5a = () => interopDefault(import('../../../pages/solar-previous-terms.vue' /* webpackChunkName: "pages/solar-previous-terms" */))
const _74979d56 = () => interopDefault(import('../../../pages/solar-terms.vue' /* webpackChunkName: "pages/solar-terms" */))
const _5df21fe1 = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _27990b64 = () => interopDefault(import('../../../pages/tips.vue' /* webpackChunkName: "pages/tips" */))
const _c85b22e8 = () => interopDefault(import('../../../pages/troubleshooting-ihd.vue' /* webpackChunkName: "pages/troubleshooting-ihd" */))
const _03bf447e = () => interopDefault(import('../../../pages/unhappy.vue' /* webpackChunkName: "pages/unhappy" */))
const _9acc6360 = () => interopDefault(import('../../../pages/use-less-energy.vue' /* webpackChunkName: "pages/use-less-energy" */))
const _d9148b5a = () => interopDefault(import('../../../pages/quoteSignUpComplete/sign-up-complete.vue' /* webpackChunkName: "pages/quoteSignUpComplete/sign-up-complete" */))
const _5e528548 = () => interopDefault(import('../../../pages/solar/so-spooky.vue' /* webpackChunkName: "pages/solar/so-spooky" */))
const _71a95356 = () => interopDefault(import('../../../pages/blog/page/_page.vue' /* webpackChunkName: "pages/blog/page/_page" */))
const _756f8fba = () => interopDefault(import('../../../pages/blog/_postId.vue' /* webpackChunkName: "pages/blog/_postId" */))
const _0f630c81 = () => interopDefault(import('../../../pages/CC33/_id.vue' /* webpackChunkName: "pages/CC33/_id" */))
const _0649494a = () => interopDefault(import('../../../pages/elmo/_id.vue' /* webpackChunkName: "pages/elmo/_id" */))
const _572ca1f7 = () => interopDefault(import('../../../pages/r/_id.vue' /* webpackChunkName: "pages/r/_id" */))
const _98173ca8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _dc88db28 = () => interopDefault(import('../../../pages/_marketingPage.vue' /* webpackChunkName: "pages/_marketingPage" */))
const _8ada4378 = () => interopDefault(import('../../../pages/_marketingFolder/_marketingSubPage.vue' /* webpackChunkName: "pages/_marketingFolder/_marketingSubPage" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _d786f232,
    name: "about"
  }, {
    path: "/accessibility-statement",
    component: _288d110a,
    name: "accessibility-statement"
  }, {
    path: "/blog",
    component: _e8ad238a,
    name: "blog"
  }, {
    path: "/careers",
    component: _45b2af8f,
    name: "careers"
  }, {
    path: "/CC33",
    component: _1a8a304e,
    name: "telesales"
  }, {
    path: "/checker",
    component: _78bdd2e2,
    name: "checker"
  }, {
    path: "/checker2",
    component: _9ecd369a,
    name: "checker2"
  }, {
    path: "/cookies",
    component: _119a8c69,
    name: "cookies"
  }, {
    path: "/elmo",
    component: _6df5d33c,
    name: "elmo"
  }, {
    path: "/emergency",
    component: _2d5bd42a,
    name: "emergency"
  }, {
    path: "/energy-source-vote",
    component: _57886ea6,
    name: "energy-source-vote"
  }, {
    path: "/esb",
    component: _48a089ce,
    name: "esb"
  }, {
    path: "/get-a-quote",
    component: _2958f31a,
    name: "get-a-quote"
  }, {
    path: "/heat-pump",
    component: _6e571e7f,
    name: "heat-pump"
  }, {
    path: "/justmovein",
    component: _6d9e8f90,
    name: "justmovein"
  }, {
    path: "/maintenance",
    component: _f791ac26,
    name: "maintenance"
  }, {
    path: "/modern-slavery-statement",
    component: _4732c4a8,
    name: "modern-slavery-statement"
  }, {
    path: "/moving-home",
    component: _91068f50,
    name: "moving-home"
  }, {
    path: "/moving-in",
    component: _3236e1de,
    name: "moving-in"
  }, {
    path: "/our-energy",
    component: _6fc4d03f,
    name: "our-energy"
  }, {
    path: "/our-tariffs",
    component: _696953a8,
    name: "our-tariffs"
  }, {
    path: "/policy",
    component: _00a9d070,
    name: "policy"
  }, {
    path: "/prepayment",
    component: _42bdc519,
    name: "prepayment"
  }, {
    path: "/press",
    component: _a44886c6,
    name: "press"
  }, {
    path: "/privacy",
    component: _5e416e3c,
    name: "privacy"
  }, {
    path: "/quote",
    component: _e89cdb54,
    children: [{
      path: "",
      component: _69e08059,
      name: "quote"
    }, {
      path: "payment-details",
      component: _e987c47c,
      name: "quote-payment-details"
    }, {
      path: "personal-details",
      component: _37c11b04,
      name: "quote-personal-details"
    }, {
      path: "select-tariff",
      component: _677f0bc8,
      name: "quote-select-tariff"
    }]
  }, {
    path: "/r",
    component: _6e74f7cf,
    name: "referral-landing-page"
  }, {
    path: "/refer-terms",
    component: _20e35554,
    name: "refer-terms"
  }, {
    path: "/refund-policy",
    component: _4e3204fe,
    name: "refund-policy"
  }, {
    path: "/reviews",
    component: _6d44d016,
    name: "reviews"
  }, {
    path: "/so-flex-tariff-rates",
    component: _85f8cb3a,
    name: "so-flex-tariff-rates"
  }, {
    path: "/so-out-of-contract-tariff",
    component: _67657e13,
    name: "so-out-of-contract-tariff"
  }, {
    path: "/solar-previous-terms",
    component: _4152dd5a,
    name: "solar-previous-terms"
  }, {
    path: "/solar-terms",
    component: _74979d56,
    name: "solar-terms"
  }, {
    path: "/terms",
    component: _5df21fe1,
    name: "terms"
  }, {
    path: "/tips",
    component: _27990b64,
    name: "tips"
  }, {
    path: "/troubleshooting-ihd",
    component: _c85b22e8,
    name: "troubleshooting-ihd"
  }, {
    path: "/unhappy",
    component: _03bf447e,
    name: "unhappy"
  }, {
    path: "/use-less-energy",
    component: _9acc6360,
    name: "use-less-energy"
  }, {
    path: "/quote/sign-up-complete",
    component: _d9148b5a,
    name: "sign-up-complete"
  }, {
    path: "/solar/so-spooky",
    component: _5e528548,
    name: "solar-so-spooky"
  }, {
    path: "/blog/page/:page?",
    component: _71a95356,
    name: "blog-list"
  }, {
    path: "/blog/:postId",
    component: _756f8fba,
    name: "blog-post"
  }, {
    path: "/CC33/:id",
    component: _0f630c81,
    name: "CC33-id"
  }, {
    path: "/elmo/:id",
    component: _0649494a,
    name: "elmo-id"
  }, {
    path: "/r/:id",
    component: _572ca1f7,
    name: "r-id"
  }, {
    path: "/",
    component: _98173ca8,
    name: "home"
  }, {
    path: "/:marketingPage",
    component: _dc88db28,
    name: "marketingPage"
  }, {
    path: "/:marketingFolder/:marketingSubPage?",
    component: _8ada4378,
    name: "marketingFolder-marketingSubPage"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
